import gql from "graphql-tag";

export const MARK_NOTIFICATION_AS_READ_MUTATION = gql`
  mutation MarkNotificationAsRead($data: MarkNotificationAsReadInput!) {
    markNotificationAsRead(data: $data)
  }
`;
